// extracted by mini-css-extract-plugin
export default {"robotList":"robot-list_robotList__rl3-d","choosed":"robot-list_choosed__vsNYC","robotAvatar":"robot-list_robotAvatar__nZdVJ"};